import { ResponseObjectEntity } from '@/model/CommonModel';
import { HelpFeature, HelpModel } from '@/model/HelpModel';
import { Api } from './api';

class HelpApi extends Api {
	constructor() {
		super();
	}

	public getHelp = async (helpFeatures: HelpFeature[]): Promise<ResponseObjectEntity<Map<HelpFeature, HelpModel[]>>> => {
		const url = this.getUrl(`Help/GetHelp`, true);
		const data = {
			helpFeatures,
		};

		return await this.post<ResponseObjectEntity<Map<HelpFeature, HelpModel[]>>>(url, data);
	};
}

const helpApi = new HelpApi();

export { helpApi };
